export const TlSettingsEmployerRoutes = [
    {
        "url": "/schedule-settings?activeTab",
        "name": "appLayout.schedule.settings",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/special-events/special-events.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/break-waivers/break-waivers.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/organization-settings/organization-settings.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/geo-fencing/geo-fencing.downgrade.module");
                }
            }
        ]
    }
];
//# sourceMappingURL=tl-settings-employer.routes.js.map